import lazyLoading from "./lazyLoading";

export default {
  name: "analysers",
  path: "/analysers",
  component: lazyLoading("analysers/Analysers"),
  meta: {
    default: false,
    title: "Analizatori",
    class: "info",
    show: true,
    iconClass: "glyphicon glyphicon-object-align-bottom",
    requiredAuth: true
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/analysers.js